import { useContext } from 'react';
import HoneyShotsContext from '../contexts/HoneyShotsContext';

const useHoneyShots = () => useContext(HoneyShotsContext);

export default useHoneyShots;
